export default {
    logout() {
        this.$store.commit('unsetTokens')
        this.$router.push({name: 'Home', params: {id: this.$store.state.trip.id, keepCart: true}})
        this.$cookie.delete('token', {domain: 'voudetrip.com.br'});
    }
}